import { HomeTeacherVideoTable } from './HomeTeacherVideoTable';
export default HomeTeacherVideoTable;
